import { useState, useRef } from 'react'

export default () => {
    const ref = useRef(null)
    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    return {open, ref, handleClose, handleClick}
}